"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ApplicationHeader = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _debounce = _interopRequireDefault(require("lodash/fp/debounce"));

var _classnames = _interopRequireDefault(require("classnames"));

var _AppMenu = require("./AppMenu");

var _ApplicationActionBar = require("./ApplicationActionBar");

var _NavItems = _interopRequireDefault(require("./NavItems"));

var _modulePropTypes = _interopRequireDefault(require("./modulePropTypes"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var RESIZE_THROTTELING = 10;
var MOBILE_MAX_WIDTH = 580; //const COLLAPSED_DROPDOWN_WIDTH = 50;

var ApplicationHeader = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ApplicationHeader, _PureComponent);

  var _super = _createSuper(ApplicationHeader);

  function ApplicationHeader(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ApplicationHeader);
    _this = _super.call(this, props);
    _this.state = {
      containerWidth: 0,
      brandWidth: 0,
      renderNavigation: false,
      isMobile: false
    };
    _this.handleWindowResize = _this.handleWindowResize.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ApplicationHeader, [{
    key: "isMobile",
    value: function isMobile() {
      //const node = this.navRef;
      // FIXME: collision check need to be done after second rendering of NavItems

      /*let isColliding = false;
       // check for collision of NavItems and ActionBar
      if (this.refNavItems && this.refActionBar) {
          const navItemsNode = ReactDOM.findDOMNode(this.refNavItems);
          const actionBarNode = ReactDOM.findDOMNode(this.refActionBar);
           // first empty <li> and second would be the collapsed dropdown
          const navItemsCount = navItemsNode.childElementCount;
          const collapsedDropdown = navItemsNode.children.item(1);
          if (navItemsCount === 2 && collapsedDropdown) {
              //isColliding = navItemsNode.scrollWidth - actionBarNode.scrollWidth < COLLAPSED_DROPDOWN_WIDTH;
              //console.log("isColliding=" + isColliding + " | clientWidth=" + node.clientWidth);
               const navItemsRight = navItemsNode.offsetLeft + collapsedDropdown.scrollWidth;
              const actionBarItemsLeft = actionBarNode.offsetLeft;
               isColliding = navItemsRight > actionBarItemsLeft;
              console.log({ isColliding, navItemsRight, actionBarItemsLeft });
          }
      }*/
      return (
        /*isColliding || */
        this.getContainerWidth() < MOBILE_MAX_WIDTH && this.props.label
      );
    }
  }, {
    key: "getContainerWidth",
    value: function getContainerWidth() {
      //return this.navRef.clientWidth;
      return window.innerWidth;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.resizer = (0, _debounce.default)(RESIZE_THROTTELING)(this.handleWindowResize);
      window.addEventListener('resize', this.resizer);
      this.setState(function () {
        return {
          containerWidth: _this2.getContainerWidth(),
          renderNavigation: true,
          isMobile: _this2.isMobile()
        };
      });
      this.props.onMount();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizer);
      this.props.onUnmount();
    }
  }, {
    key: "handleWindowResize",
    value: function handleWindowResize() {
      var _this3 = this;

      this.setState(function () {
        return {
          renderNavigation: true,
          containerWidth: _this3.getContainerWidth(),
          isMobile: _this3.isMobile()
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          homeRoute = _this$props.homeRoute,
          showHomeIcon = _this$props.showHomeIcon,
          label = _this$props.label,
          className = _this$props.className,
          appNavigator = _this$props.appNavigator,
          appNavigatorClassName = _this$props.appNavigatorClassName,
          appMenuItems = _this$props.appMenuItems,
          navItems = _this$props.navItems,
          actionBarItems = _this$props.actionBarItems;
      var classNames = (0, _classnames.default)('ApplicationHeader', 'navbar navbar-default', 'user-select-none', this.state.isMobile && 'mobile', className && className);

      var renderNavItems = /*#__PURE__*/_react.default.createElement(_NavItems.default, {
        key: "NavItems",
        navItems: navItems,
        isMobile: this.state.isMobile,
        containerWidth: this.state.containerWidth,
        actionBarItems: this.state.isMobile && actionBarItems,
        ref: function ref(node) {
          return _this4.refNavItems = node;
        }
      });

      var renderActionItems = !this.state.isMobile && /*#__PURE__*/_react.default.createElement(_ApplicationActionBar.ApplicationActionBar, {
        nodeRef: function nodeRef(node) {
          return _this4.refActionBar = node;
        },
        items: actionBarItems
      });

      return /*#__PURE__*/_react.default.createElement("nav", {
        className: classNames,
        ref: function ref(node) {
          return _this4.navRef = node;
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "navbar-header"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "navbar-brand ".concat(showHomeIcon ? 'home-icon' : '')
      }, homeRoute)), label && /*#__PURE__*/_react.default.createElement(_AppMenu.AppMenu, {
        label: label,
        key: "AppMenu",
        appMenuItems: appMenuItems,
        appNavigator: appNavigator,
        appNavigatorClassName: appNavigatorClassName
      }), navItems && renderNavItems, renderActionItems);
    }
  }]);
  return ApplicationHeader;
}(_react.PureComponent);

exports.ApplicationHeader = ApplicationHeader;
var _default = ApplicationHeader;
exports.default = _default;
ApplicationHeader.defaultProps = {
  homeRoute: '',
  showHomeIcon: true,
  actionBarItems: [],
  onMount: function onMount() {},
  onUnmount: function onUnmount() {}
};
ApplicationHeader.propTypes = {
  label: _propTypes.default.node,
  className: _propTypes.default.string,
  homeRoute: _propTypes.default.node.isRequired,
  showHomeIcon: _propTypes.default.bool,
  appMenuItems: _propTypes.default.arrayOf(_modulePropTypes.default),
  appNavigator: _propTypes.default.node,
  appNavigatorClassName: _propTypes.default.string,
  navItems: _propTypes.default.arrayOf(_modulePropTypes.default),
  actionBarItems: _propTypes.default.arrayOf(_propTypes.default.node),
  onMount: _propTypes.default.func,
  onUnmount: _propTypes.default.func
};